<template>
    <div>
        <p class="ma-0 d-flex subtitle-1 align-center">
            {{$t('Select a category for this product (optional) or ')}} <v-btn class="ml-3 small-btns" @click="addNewCategory()" color="secondary" dark>{{$t('Add a new category')}}</v-btn>
        </p>

        <v-progress-circular
                v-if="loading"
                indeterminate
                color="primary"
        ></v-progress-circular>
        <div v-if="$product.product && $product.product.categories">
            <div v-expand>
                <v-treeview
                        selection-type="independent"
                        :items="all"
                        item-text="name"
                        item-value="id"
                        selectable
                        v-model="tmp"
                ></v-treeview>
            </div>
            <edit-add-category></edit-add-category>

        </div>
    </div>
</template>
<script>
    import {getCategories} from "../../api/categories";
    import EditAddCategory from '../categories/edit-add-dialog'
    export default {
        components:{EditAddCategory},
        props:['product'],
        data:() => {
            return{
                all: [],
                loading: false,
                tmp: [],
            }
        },
        watch:{
            tmp: function () {
                this.product.product.categories = this.tmp;
            }
        },
        mounted() {
            this.getCategories();
        },
        methods:{
            getCategories(){
                return new Promise((resolve, reject) => {
                    this.loading = true;
                    getCategories().then(response => {
                        this.loading = false;
                        this.all = response;
                        setTimeout(()=>{
                            this.tmp = this.product.product.categories;
                        },500)
                        resolve(response);
                    })
                })
            },
            addNewCategory(){
                this.$editAddCategory.addCategory().then(cat => {
                    this.getCategories().then(res => {
                        this.tmp.push(cat.id);
                    });
                })
            }
        }
    }
</script>
